import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import Text from '../../input_filed/Text';
import Email from '../../input_filed/Email';
import Password from '../../input_filed/Password';
import SingleSelect from '../../input_filed/SingleSelect';
import File from '../../input_filed/File';
import SaveButton from '../../buttons/SaveButton';
import { Col, Form, Row } from 'react-bootstrap';
import { designationListTodo } from '../../../redux/slices/master/designation/DesignationList';
import { departmentListTodo } from '../../../redux/slices/master/department/DepartmentList';
import Loader from '../../loader/Loader';
import { userSchema } from './ValidationSchema';
import { addUserTodo } from '../../../redux/slices/user/AddUser';
import { toast, ToastContainer } from 'react-toastify';

const AddUserForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const [spiner, setSpiner] = useState(false);
    const designationList = useSelector(state => state?.designationList?.data?.data)
    const departmentList = useSelector(state => state?.departmentList?.data?.data)

    const designation_option = designationList?.map(val => (
        { "value": val?._id, "label": val?.name }
    ))

    const department_option = departmentList?.map(val => (
        { "value": val?._id, "label": val?.name }
    ))

    const status_option = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' }
    ];

    // const roleList = [
    //     { value: 'admin', label: 'Admin' },
    //     { value: 'engineer', label: 'Engineer' },
    //     { value: 'operator', label: 'Operator' },
    //     { value: 'viewer', label: 'Viewer' },
    // ];


    const initiaValues = {
        user_name: '',
        phone_no: '',
        email: '',
        password: '',
        confirm_password: '',
        // role: 'staff', // static; not shown in UI
        profile_image: '',
        department: '',
        designation: '',
        // path: 'category', // static; not shown in UI
        status: '', // static; not shown in UI
        role: 'staff', // static userRole
        path: 'category', // static path
    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initiaValues,
        validationSchema: userSchema,

        onSubmit: (values, action) => {
            setSpiner(true)
            dispatch(addUserTodo(values)).then((res) => add_res(res))
        }
    })

    const add_res = (res) => {
        if (res?.payload?.status == 201) {
            toast.success(res?.payload?.data?.message, { position: "bottom-right" });
            setTimeout(() => {
                setSpiner(false);
                navigate('/user-list')
            }, 1000);
        } else if (res?.payload?.status == 401) {
            localStorage.clear();
            navigate('/login')
            setSpiner(false);
        } else if (res?.payload?.status == 400) {
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
            setSpiner(false);
        } else if (res?.payload?.status == 404) {
            toast.error('Not Found', { position: "bottom-right" });
            setSpiner(false);
        } else {
            setSpiner(false);
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
        }
    }

    useEffect(() => {
        setLoading(true)
        Promise.all([
            dispatch(designationListTodo({
                navigate, status: 'Active'
            })),
            dispatch(departmentListTodo({
                navigate, status: 'Active'
            })),
        ]).finally(() => setLoading(false));
    }, [])


    return (
        <>
            <div className='main_layout p-3'>
                <div className='layout_head mb-3'>
                    <h5>Add User</h5>
                </div>
                <hr />
                {
                    loading ?
                        <div className='p-5'>
                            <Loader />
                        </div>
                        :
                        <Form onSubmit={handleSubmit}>
                            <Row>
                                <Col xl='3'>
                                    <Text label_name='Name' name='user_name' value={values.user_name} onChange={handleChange} onBlur={handleBlur}
                                        error={errors.user_name && touched.user_name && <span className='text-danger form_label'>{errors.user_name}</span>}
                                    />
                                </Col>
                                <Col xl='3'>
                                    <Text label_name='Contact No.' name='phone_no' value={values.phone_no} onChange={handleChange} onBlur={handleBlur}
                                        error={errors.phone_no && touched.phone_no && <span className='text-danger form_label'>{errors.phone_no}</span>}
                                    />
                                </Col>
                                <Col xl='3'>
                                    <Email label_name='Email' name='email' value={values.email} onChange={handleChange} onBlur={handleBlur}
                                        error={errors.email && touched.email && <span className='text-danger form_label'>{errors.email}</span>}
                                    />
                                </Col>
                                <Col xl='3'>
                                    <Password label_name='Password' name='password' value={values.password} onChange={handleChange} onBlur={handleBlur}
                                        error={errors.password && touched.password && <span className='text-danger form_label'>{errors.password}</span>}
                                    />
                                </Col>
                                <Col xl='3'>
                                    <Password label_name='Confirm Password' name='confirm_password' value={values.confirm_password} onChange={handleChange} onBlur={handleBlur}
                                        error={errors.confirm_password && touched.confirm_password && <span className='text-danger form_label'>{errors.confirm_password}</span>}
                                    />
                                </Col>
                                {/* <Col xl='3'>
                                    <SingleSelect label_name='Role' option={roleList} name='role'
                                        onChange={(e) => setFieldValue('role', e.value)}
                                        onBlur={handleBlur}
                                        error={errors.role && touched.role && <span className='text-danger form_label'>{errors.role}</span>}
                                    />
                                </Col> */}
                                {/* Admin role not used; always require department and designation */}
                                <Col xl='3'>
                                    <SingleSelect label_name='Department' option={department_option} name='department'
                                        onChange={(e) => setFieldValue('department', e.value)} onBlur={handleBlur}
                                        error={errors.department && touched.department && <span className='text-danger form_label'>{errors.department}</span>}
                                    />
                                </Col>
                                <Col xl='3'>
                                    <SingleSelect label_name='Designation' option={designation_option} name='designation'
                                        onChange={(e) => setFieldValue('designation', e.value)} onBlur={handleBlur}
                                        error={errors.designation && touched.designation && <span className='text-danger form_label'>{errors.designation}</span>}
                                    />
                                </Col>
                                <Col xl='3'>
                                    <File label_name='Profile Image' name='profile_image'
                                        onChange={(e) => setFieldValue('profile_image', e.currentTarget.files[0])}
                                        onBlur={handleBlur}
                                        error={errors.profile_image && touched.profile_image && <span className='text-danger form_label'>{errors.profile_image}</span>}
                                    />
                                </Col>
                                <Col xl='3'>
                                    <SingleSelect label_name='Status' option={status_option} name='status'
                                        onChange={(e) => setFieldValue('status', e.value)} onBlur={handleBlur}
                                        error={errors.status && touched.status && <span className='text-danger form_label'>{errors.status}</span>}
                                    />
                                </Col>
                                <Col xl='12' className='d-flex justify-content-end'>
                                    <SaveButton name={'SAVE'} spiner={spiner} />
                                </Col>
                            </Row>
                        </Form>}

            </div>
        </>
    );
};

export default AddUserForm;
